module.exports = __webpack_public_path__ + "img/bgr-valentine.65c2c0f1.svg";